import { render, staticRenderFns } from "./FuelType.vue?vue&type=template&id=22554b99&"
import script from "./FuelType.vue?vue&type=script&lang=js&"
export * from "./FuelType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports